import { Component, h } from 'preact';
import { connect } from 'preact-redux';

class ReadingHeaderPrice extends Component {
    constructor() {
        super();

        this.on_sale = false;
    }

    render({ price, teeup, subscription }) {
        let render = false;

        if (price) {
            if (price.usd && price.usd.original && price.usd.current) {
                this.on_sale = (price.usd.original - price.usd.current) > 0;
            }

            render = price.usd && price.usd.current !== 0;

            if (teeup && teeup.upsell_upc) {
                render = false;
            }

            if (subscription) {
                render = true;
            }
        }

        if (render) {
            return (
                <reading-header-price>
                    {this.renderOnSale()}
                    {this.renderPrice()}
                </reading-header-price>
            );
        }

        return (
            <reading-header-price />
        );
    }

    renderOnSale = () => {
        const price = this.props.price;

        if (this.on_sale) {
            return (
                <s>${ price.usd.original.toFixed(2) } or { price.kc.original } KCs</s>
            );
        }

        return null;
    }

    renderPrice = () => {
        if (this.props.price) {
            const price = this.props.price;
            const subscription = this.props.subscription;
            let text = '';

            if (price.usd && price.usd.current !== null) {
                text = `\$${price.usd.current.toFixed(2)}`;

                if (price.kc) {
                    text = text + ` or ${price.kc.current} KCs`;
                }
            } else {
                text = `${price.kc.current} KCs`;

                if (subscription) {
                    text = text + ` OR <a href="${subscription.description.product_url}">SUBSCRIBE</a>`;
                }
            }

            return (
                <p class='pre-header reading-price'>
                    <span class={this.on_sale ? 'sale' : ''} dangerouslySetInnerHTML={{__html: text}} />
                </p>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    price: state.product.price,
    subscription: state.product.subscription,
    teeup: state.product.teeup,
});

export default connect(mapStateToProps)(ReadingHeaderPrice);



// WEBPACK FOOTER //
// ./app/components/reading-header-price.js